// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"84612dac","70":"a6b3f0a9","147":"84372bb9","162":"491118fc","236":"fbdee44a","259":"effcf220","285":"e0146d7e","453":"f91c002f","528":"4151fdcc","646":"2f4667a2","906":"798a2af3","935":"e145d3d3"}[chunkId] + ".chunk.js";
};